import m, {type Children, MithrilComponent} from '@bitstillery/mithril'
import {rich_text} from '@bitstillery/common/cms/lib/inline_markup'

import type {CmsComponentMeta} from '@bitstillery/common/cms/catalog_meta'

export const quoteMeta = {
    tier: 'content',
    summary: 'In-flow pull quote (`blockquote`) with optional attribution.',
    when_to_use: 'Distinct from `QuoteCard`, which is a callout card.',
    example: `
    <Quote attribution="Cor, Account manager">We ship the same day.</Quote>
    `,
} satisfies CmsComponentMeta

export interface QuoteAttrs {
    /** Optional source line shown below the quote (e.g. a name/role). */
    attribution?: Children
}

/** In-flow pull quote (`blockquote`). Distinct from `QuoteCard`, which is a callout card. */
export class Quote extends MithrilComponent<QuoteAttrs> {
    view(vnode: m.Vnode<QuoteAttrs>) {
        return (
            <figure className='cms-quote'>
                <blockquote>{rich_text(vnode.children)}</blockquote>
                {vnode.attrs.attribution ? <figcaption>{rich_text(vnode.attrs.attribution)}</figcaption> : null}
            </figure>
        )
    }
}
